import { useEffect, useState } from "react";
import api from "@/lib/api";

function Stat({ label, value, testid }) {
  return (
    <div className="border border-[#E8E1D8] bg-white p-5" data-testid={testid}>
      <p className="label-x">{label}</p>
      <p className="font-display text-2xl mt-2">{value}</p>
    </div>
  );
}

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <p className="label-x">LADEN…</p>;
  return (
    <div data-testid="admin-dashboard">
      <h1 className="heading-x text-2xl mb-6">DASHBOARD</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="OMZET" value={`€${d.revenue.toFixed(2)}`} testid="stat-revenue" />
        <Stat label="BESTELLINGEN" value={d.orders_total} testid="stat-orders" />
        <Stat label="BETAALD" value={d.orders_paid} testid="stat-paid" />
        <Stat label="FULFILMENT OPEN" value={d.fulfilment_pending} testid="stat-pending" />
        <Stat label="AJDN FOUTEN" value={d.ajdn_errors} testid="stat-ajdn-errors" />
        <Stat label="VERZONDEN" value={d.shipped} testid="stat-shipped" />
        <Stat label="PRODUCTEN" value={d.products} testid="stat-products" />
        <Stat label="LAGE VOORRAAD" value={d.low_stock} testid="stat-low-stock" />
        <Stat label="KLANTEN" value={d.customers} testid="stat-customers" />
      </div>
      <div className="mt-8 border border-[#E8E1D8] bg-white p-6">
        <p className="label-x mb-4">BESTSELLERS</p>
        {d.best_sellers.length === 0 ? <p className="text-sm text-[#77736D]">Nog geen betaalde bestellingen.</p> : (
          <ul className="space-y-2">{d.best_sellers.map((b, i) => <li key={i} className="flex justify-between text-sm"><span>{b.name}</span><span className="font-mono">{b.qty} verkocht</span></li>)}</ul>
        )}
      </div>
    </div>
  );
}
